import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { AppSidebar } from '@/components/layout/AppSidebar/AppSidebar';
import { useAuthStore } from '@/features/auth/store/auth-store';
import { useSyncWorkspace } from '@/features/workspaces/hooks/use-sync-workspace';

import './default-layout.scss';

function DefaultLayout() {
  // Sync workspace data from server on mount (background refresh)
  useSyncWorkspace();

  return (
    <div className="default-layout">
      <AppSidebar />
      <main className="default-layout-content">
        <Outlet />
      </main>
    </div>
  );
}

export const Route = createFileRoute('/_default')({
  component: DefaultLayout,
  beforeLoad: () => {
    const { isAuthenticated, hasWorkspace } = useAuthStore.getState();

    // If authenticated but no workspace, redirect to onboarding
    if (isAuthenticated && !hasWorkspace) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router redirect pattern
      throw redirect({ to: '/onboarding/create-workspace' });
    }
  },
});
